/* pl-pages.js — スクロール表示アニメーション (pl-reveal / pl-stagger)
   - DOMContentLoaded + shopify:section:load で初期化
   - Shopify.designMode（テーマエディタ内）では即時表示
   - prefers-reduced-motion: reduce では即時表示 */
(function () {
  var observer;

  function shouldDisableAnimation() {
    return (
      (typeof Shopify !== 'undefined' && Shopify.designMode) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function showImmediately(scope) {
    (scope || document).querySelectorAll('.pl-reveal, .pl-stagger').forEach(function (el) {
      el.classList.add('pl-is-in');
    });
  }

  function setupObserver() {
    if (observer) return;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pl-is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
  }

  function observeTargets(scope) {
    var targets = (scope || document).querySelectorAll('.pl-reveal, .pl-stagger');
    targets.forEach(function (el) {
      if (el.classList.contains('pl-is-in')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('pl-is-in');
      } else {
        observer.observe(el);
      }
    });
  }

  function init(e) {
    var scope = (e && e.type === 'shopify:section:load') ? e.target : null;
    if (shouldDisableAnimation()) {
      showImmediately(scope);
      return;
    }
    setupObserver();
    observeTargets(scope);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
